
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
const Rootrouter=()=>{
    return(
        <div className="topcontainer">
            <ToastContainer />
            <Outlet/>
        </div>
    )
}
export default Rootrouter;